var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((12),function(i){return _c('v-col',{key:i,attrs:{"cols":"6","sm":"4","md":"3","lg":"2"}},[_c('v-skeleton-loader',{attrs:{"type":"card-avatar"}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }